// External Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'material-ui/Chip';
import grey700 from 'material-ui/styles/colors';

// Internal Dependencies
import { BadgeStrings } from '../common/strings';

// Local Variables
const propTypes = {
  badges: PropTypes.arrayOf(PropTypes.object),
  coderBadges: PropTypes.array,
  details: PropTypes.string,
  size: PropTypes.string,
};

const options = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

const badgeInfoText = {
  fontSize: 12,
  color: grey700,
  fontWeight: '300',
  lineHeight: '17px',
};

const badgeDiv = {
  float: 'left',
  display: 'inline',
};

const noBadgeDiv = {
  margin: 25,
  textAlign: 'center',
  paddingLeft: 20,
};

const noBadgeChip = {
  textAlign: 'center',
  background: '#A7FFEB',
  color: 'white',
};

const noBadgelabelColor = '#546E7A';

const emptyDiv = {
  margin: '20%',
};

// Component definition
const CoderCardBadgeList = (props) => {
  const {
    badges,
    coderBadges,
    details,
    size,
  } = props;

  const imageSize = size || '60px';

  try {
    if (coderBadges !== null) {
      return (
        <div>
          {
            Object.keys(coderBadges).map((key, index) => {
              const image = `${window.location.pathname}images/badges/${badges[coderBadges[key].badgeKey].image}`;
              if (details) {
                return (
                  <div key={index} style={badgeDiv}>
                    <img alt={image} height={imageSize} src={image} width={imageSize} />
                    <div style={badgeInfoText}>
                      {badges[coderBadges[key].badgeKey].name}
                    </div>
                    <div style={badgeInfoText}>
                      Won: {(new Date(coderBadges[key].date)).toLocaleDateString('en-US', options)}
                    </div>
                  </div>
                );
              }
              return (
                <img alt={image} height={imageSize} key={key} src={image} width={imageSize} />
              );
            })
          }
        </div>
      );
    }
    return (
      <div style={noBadgeDiv}>
        <Chip style={noBadgeChip} labelColor={noBadgelabelColor}>
          {BadgeStrings.noBadges}
        </Chip>
      </div>
    );
  } catch (e) {
    return (
      <div style={emptyDiv} />
    );
  }
};

CoderCardBadgeList.propTypes = propTypes;
export default CoderCardBadgeList;



/** WEBPACK FOOTER **
 ** ./src/ninjas/CoderCardBadgeList.js
 **/